// Global packages and components
import { clsx } from 'clsx'
import { RefObject } from 'react'
import { Button, Price } from '~/components'
import { PriceValue } from '~/types'

// Types
interface Props {
  blockRef: RefObject<HTMLDivElement>
  isRefVisible: boolean
  productType: string
  fromPrice: PriceValue | null
  salePrice: PriceValue | null
}

// Main export
const StickyButton = ({
  blockRef,
  isRefVisible,
  productType,
  fromPrice,
  salePrice,
}: Props) => (
  <div
    className={clsx(
      'fixed bottom-0 left-0 flex w-full border border-neutral-200 bg-white transition-transform md:hidden',
      {
        'translate-y-full': isRefVisible,
        'translate-y-none': !isRefVisible,
      }
    )}
  >
    <div className="container grid grid-cols-2 py-3">
      {fromPrice && (
        <div>
          <p className="mb-0 text-xs">
            {productType == 'bulk' ? 'Hire from' : 'Buy from'}
          </p>
          <Price
            size="lg"
            price={fromPrice}
            salePrice={salePrice}
          />
        </div>
      )}
      <Button
        style="tealGreen"
        title={productType == 'bulk' ? 'Hire now' : 'Buy now'}
        onClick={() =>
          blockRef?.current ? blockRef.current.scrollIntoView() : undefined
        }
        fullWidth
      />
    </div>
  </div>
)

export default StickyButton
